import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideMarkdown } from 'ngx-markdown';
import { NGX_ECHARTS_CONFIG } from 'ngx-echarts';
import { MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS } from '@angular/material/button-toggle';
import { oktaConfig } from './okta.config';
import { authInterceptor } from './interceptors/auth.interceptor';
import { errorHandlerInterceptor } from './interceptors/error-handler.interceptor';
import { loaderInterceptor } from './interceptors/loader.interceptor';

const oktaAuth = new OktaAuth(oktaConfig);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideMarkdown(),
    importProvidersFrom(
      OktaAuthModule.forRoot({ oktaAuth })
    ),
    provideHttpClient(
      withInterceptors([/*loaderInterceptor,*/ authInterceptor, errorHandlerInterceptor])
    ),
    {
      provide: NGX_ECHARTS_CONFIG,
      useValue: { echarts: () => import('echarts') },
    },
    {
      // Material renders a checkmark inside the selected toggle by default (since
      // v16). Nubo's segmented control is a white pill on a subtle track — see
      // styles/controls.scss — and the extra tick squeezes the label and reads as
      // a second, competing selection cue. Off everywhere, so every segmented
      // control in the app looks the same.
      provide: MAT_BUTTON_TOGGLE_DEFAULT_OPTIONS,
      useValue: { hideSingleSelectionIndicator: true, hideMultipleSelectionIndicator: true }
    }
  ]
};
